import { useLayoutEffect } from "react";

export default function useAlignHeaderBrand(formRef, brandRef) {
  useLayoutEffect(() => {
    const form = formRef.current;
    const brand = brandRef.current;
    if (!form || !brand) return;

    const align = () => {
      const nav = brand.parentElement;
      if (!nav) return;
      // if (window.innerWidth < 980) {
      //   brand.style.marginLeft = "";
      //   return;
      // }
      const next =
        form.getBoundingClientRect().left - nav.getBoundingClientRect().left;
      brand.style.marginLeft = `${Math.max(0, next)}px`;
    };

    align();
    const raf = requestAnimationFrame(align);
    const later = window.setTimeout(align, 80);
    const ro = new ResizeObserver(align);
    ro.observe(form);
    if (form.parentElement) ro.observe(form.parentElement);
    window.addEventListener("resize", align);
    window.visualViewport?.addEventListener("resize", align);
    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(later);
      ro.disconnect();
      window.removeEventListener("resize", align);
      window.visualViewport?.removeEventListener("resize", align);
    };
  }, [formRef, brandRef]);
}
